import request from "@/utils/request";
import qs from "qs";


export function getFileListByLink(id) {
    return request({
        url: "cus/getFileListByLink/" + id,
        method: "get",
    });
}

// 提问接口(测试环境)
export function streamQuestion(data) {
    return request({
        url: "cus/chat/streamQuestion/balance",
        method: "post",
        data,
    });
}

// 评价
export function setFaqEvaluate(data) {
    return request({
        url: "cus/chat/setFaqEvaluate",
        method: "post",
        data,
    });
}



// WEBPACK FOOTER //
// ./src/api/robot.js